export class Communication {
    constructor() {
        this.phone = null;
        this.email = null;
        this.fax = null;
    }
}
